import { ActionTypes } from "../constants/action-types"

export const isPWA=(value)=>{
    return {
      type:ActionTypes.IS_PWA,
      payload:value,
    }
  }
  
export const isGuest = (value) => {
  return {
    type: ActionTypes.IS_GUEST,
    payload: value,
  }
}

export const isVisited = (value) => {
  return {
    type: ActionTypes.IS_VISITED,
    payload: value,
  }
}

export const welcomeStep = (value) => {
  return {
    type: ActionTypes.WELCOME_STEP,
    payload: value,
  }
}

export const WelcomeJourneyState = (value) => {
  localStorage.setItem('welcome_journey', JSON.stringify(value));
  return {
    type: ActionTypes.WELCOME_JOURNEY,
    payload: value,
  }
}

export const previousNavSelect = (value) => {
  return {
    type: ActionTypes.PREVIOUS_NAV,
    payload: value,
  }
}

export const showPwaLoader = (value) => {
  return {
    type: ActionTypes.PWA_LOADER,
    payload: value,
  }
}

export const pwaLinkTagClick = (value) => {
  return {
    type: ActionTypes.PWA_LINK_TAG_CLICK,
    payload: value,
  }
}
